import { useClientPortalAPI, useSubmit } from "@certn/api";
import { showToast } from "@certn/cascadia";
import { t } from "i18next";

export function useRestrictApplicantCommunications(
  groupId: string | undefined
) {
  const { submit, isSubmitting } = useSubmit(
    `/api/internal/client-portal/customer-groups/${groupId}/toggle-restrict-applicant-communications/`
  );

  const { data, isLoading, mutate } = useClientPortalAPI(
    groupId ? `/api/internal/client-portal/customer-groups/${groupId}/` : null
  );

  const updateRestrictApplicantCommunications = async (enabled: boolean) => {
    try {
      await submit({
        restrict_applicant_communications: enabled,
      });
      await mutate();
      showToast(
        enabled ? t("Notifications disabled") : t("Notifications enabled"),
        { type: "success" }
      );
    } catch {
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    }
  };

  return {
    data,
    isLoading,
    updating: isSubmitting,
    updateRestrictApplicantCommunications,
  };
}
